module.exports = __webpack_public_path__ + "img/graph-view-icon.38950863.png";